import Vue from "vue";
import Router from "vue-router";
import JoinPage from "@/pages/JoinPage";
import PositionPages from "@/pages/PositionsList";
import ExpatsPage from "@/pages/ExpatsPage";
import PositionPage from "@/pages/PositionPage";
import ApplicationPage from "@/pages/ApplicationPage";
import OpenApplication from "@/pages/OpenApplication";
import VerifyPage from "@/pages/VerifyPage";
import Internships from "@/pages/Internships";

import {
	JOIN_PAGE_NAME,
	POSITIONS_PAGE_NAME,
	EXPATS_PAGE_NAME,
	APPLICATION_PAGE_NAME,
	POSITION_PAGE_NAME,
	OPEN_APPLICATION_PAGE_NAME,
	INTERNSHIPS_PAGE_NAME,
	SUBSCRIBE_PAGE_NAME,
	UNSUBSCRIBE_PAGE_NAME,
	VERIFY_SUBSCRIPTION_PAGE_NAME
} from "./pageConstants";
import SubscribePage from "../pages/SubscribePage.vue";
import UnsubscribePage from "../pages/UnsubscribePage.vue";

Vue.use(Router);

const routes = [
	{
		path: "/",
		name: JOIN_PAGE_NAME,
		component: JoinPage
	},
	{
		path: "/positions",
		name: POSITIONS_PAGE_NAME,
		component: PositionPages
	},
	{
		path: "/expats",
		name: EXPATS_PAGE_NAME,
		component: ExpatsPage
	},
	{
		path: "/position/:slug",
		name: POSITION_PAGE_NAME,
		component: PositionPage,
		meta: {
			mainPage: false
		}
	},
	{
		path: "/application",
		name: APPLICATION_PAGE_NAME,
		component: ApplicationPage
	},
	{
		path: "/open-application",
		name: OPEN_APPLICATION_PAGE_NAME,
		component: OpenApplication
	},
	{
		path: "/internships",
		name: INTERNSHIPS_PAGE_NAME,
		component: Internships
	},
	{
		path: "/subscribe",
		name: SUBSCRIBE_PAGE_NAME,
		component: SubscribePage
	},
	{
		path: "/subscribe/verify",
		name: VERIFY_SUBSCRIPTION_PAGE_NAME,
		component: VerifyPage
	},
	{
		path: "/unsubscribe/:slug",
		name: UNSUBSCRIBE_PAGE_NAME,
		component: UnsubscribePage
	}
];

const scrollBehavior = (to, from, savedPosition) => {
	if (savedPosition) {
		return savedPosition;
	} else if (to.name !== from.name) {
		return { x: 0, y: 0 };
	}
};

export default new Router({
	mode: "history",
	routes,
	scrollBehavior
});



// WEBPACK FOOTER //
// ./src/router/index.js